<template>
	<div>
		<div class="upload-box">
			<draggable v-model="images" class="upload-box-draggable" handle=".mover" filter=".forbid" animation="300" @end="updateModel">
				<template v-if="images.length > 0">
					<div v-for="(item, index) in images" :key="item.key" class="preview-box">
						<div v-if="item.status == 1" class="waiting">
							<div class="waiting-txt">等在上传...</div>
							<div class="name v-ellipsis v-mt-10 v-font-12">{{ item.name }}</div>
						</div>
						<div v-if="item.status == 2" class="progress">
							<el-progress class="progress-bar" :text-inside="true" :stroke-width="24" :percentage="item.percent" status="success"></el-progress>
							<div class="name v-ellipsis v-mt-10 v-font-12">{{ item.name }}</div>
						</div>
						<template v-if="item.status == 3">
							<img class="preview" :src="`${item.preview}?imageView2/1/w/200/h/100`" />
							<div class="preview-footer">
								<input v-model="item.name" class="name" type="text" size="mini" @input="updateModel" /> <i class="mover operate-btn el-icon-rank"></i> <i class="operate-btn el-icon-zoom-in" @click="openWindow(item.preview)"></i> <i class="operate-btn el-icon-delete" @click="deleteImage(index)"></i>
							</div>
						</template>
					</div>
				</template>
				<div class="upload-btn v-col v-center" @click="chooseImage(false)">
					<i class="icon el-icon-plus"></i>
					<div class="txt">全景图</div>
				</div>
			</draggable>
		</div>

		<input ref="file" type="file" hidden accept="*/image" multiple="multiple" />
	</div>
</template>

<script>
	import draggable from 'vuedraggable';
	import upload from '@/utils/upload';

	export default {
		components: {draggable},

		model: {
			prop: 'imagesModel',
			event: 'change',
		},

		props: {
			loading: {
				type: Boolean,
				default: false,
			},
			imagesModel: {
				type: Array,
				default: () => []
			}
		},

		data() {
			return {
				isShowUploadDialog: false,
				images: [],
				up: [],
				max: 4,
			};
		},

		methods: {
			//选择商品图片
			chooseImage() {
				let $file = this.$refs.file;
				$file.click();
				$file.onchange = async (e) => {
					this.$emit('update:loading', true);
					let newImages = Array.from(e.target.files).map((item) => ({file: item, status: 1, percent: 0, name: item.name}));
					this.images = this.images.concat(newImages);
					this.addToUpload();
					$file.value = '';
				};
			},

			addToUpload() {
				let images = this.images;
				let uFules = images.filter((item) => item.status == 2); // status 1等待上传 2正在上传 3上传完成
				let wimages = images.filter((item) => item.status == 1);
				let dimages = images.filter((item) => item.status == 3);
				if (wimages.length && uFules.length < this.max) {
					wimages[0].status = 2;
					this.doUpload(wimages[0]);
					this.addToUpload();
				}
				if (dimages.length == images.length) {
					this.$emit('update:loading', false);
					this.updateModel();
				}
			},

			async doUpload(image) {
				try {
					let res = await upload.uploadFile(image.file, {
						progress: (e) => {
							image.percent = parseInt(e.total.percent);
						},
					});
					image.status = 3;
					image.preview = res.preview;
					image.key = res.key;
					this.addToUpload();
				} catch (e) {
					console.error(e);
				}
			},

			//删除图片
			deleteImage(index) {
				this.images.splice(index, 1);
				this.updateModel();
			},

			updateModel() {
				this.$emit('change', this.images.map((item) => ({image: item.key, name: item.name})));
			},

			openWindow(url) {
				window.open(url, '_blank');
			},

		},
	};
</script>

<style lang="scss" scoped>
	.upload-box {
	}

	.upload-box-draggable {
		display: flex;
		flex-wrap: wrap;
	}

	.upload-btn {
		border: 1px dashed #9a9a9a;
		border-radius: 4px;
		cursor: pointer;
		color: #9a9a9a;
		justify-content: center;
		box-sizing: border-box;
		margin: 0 10px 0 0;
		width: 200px;
		height: 125px;

		.icon {
			font-size: 22px;
		}

		.txt {
			font-size: 12px;
		}
	}

	.preview-box {
		position: relative;
		line-height: 1;
		margin: 0 10px 10px 0;
		width: 200px;

		&.forbid:before {
			content: '高空图';
			width: 200px;
			height: 100px;
			display: flex;
			align-items: center;
			justify-content: center;
			position: absolute;
			left: 0;
			top: 0;
			color: #fff;
			background: rgba(0, 0, 0, 0.3);
		}

		.forbid {
			display: none;
		}

		.name {
			line-height: 1.5;
		}

		.preview {
			display: block;
			width: 200px;
			height: 100px;
		}

		.preview-footer {
			display: flex;
			font-size: 12px;
			height: 26px;
			line-height: 25px;
			background: rgba(0, 0, 0, 0.3);
			color: #fff;
			align-items: center;
			transition: all 0.3s ease;
		}

		.preview-footer .name {
			flex: 1;
			font-size: 12px;
			padding: 0 10px;
			min-width: 0;
			margin: 0 5px;
			height: 20px;
			line-height: 20px;
			border: 0;
		}

		.preview-footer .operate-btn {
			color: #fff;
			margin-right: 10px;
			cursor: pointer;
			line-height: 25px;
		}

		.mover {
			cursor: move !important;
		}
	}

	.progress,
	.waiting {
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		height: 125px;
		border: 1px dashed #9a9a9a;
		border-radius: 4px;
		color: #999;
		box-sizing: border-box;
	}

	.progress-bar {
		width: 120px;
		margin: 0 auto;
	}
</style>
